import React, { useState, useEffect } from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import ArraySelect from '../../Select/ArraySelect'
import { emptyGuid, isEmptyGuid } from '../../../utils/emptyGuid'
import { StyledValidationMessage } from '../../Configuration/Articles/formHelper'
import { setValueByKey } from '../../../utils/utils'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { makeCall } from '../../../utils/api/makeCall'
import { ButtonWithLoadingState } from '../../../components/Buttons'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '../../../styles/colors'

const DividerLine = styled.div`
  height: 1px;
  background: ${colors.gray3};
  margin: 0 16px;
`
const WashSettings = (props) => {
    const { t, washStore, uiStore } = props
    const [settingsObj, setSettingsObj,] = useState(null);
    const [services, setServcices] = useState([])
    const [salesTypes, setSalesTypes] = useState([])
    const [errorStates, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})
    const [hideScanAfterTime, setHideScanAfterTime] = useState(washStore.getHideScanAfterTime())

    const loadSettings = async () => {
        await makeCall('washSettings', async () => {
            var result = await instMgmtApi.getWashSettings()
            setSettingsObj(result)
        }, setErrorStates, setLoadingStates)
    }
    const loadSalesTypes = async () => {
        await makeCall('washSalesTypes', async () => {
            var result = await instMgmtApi.getWashSalesTypes()
            setSalesTypes(result)
        }, setErrorStates, setLoadingStates)
    }
    const loadServices = async () => {
        await makeCall('washServices', async () => {
            var result = await instMgmtApi.getWashServices()
            setServcices(result)
        }, setErrorStates, setLoadingStates)
    }
    useEffect(() => {
        loadSettings()
        loadSalesTypes()
        loadServices()
    }, [])

    const updateInputFields = (e) => {
        const { target } = e
        let key = target.name
        let value = null
        switch (key) {
            case 'salesType':
            case 'defaultService':
                setSettingsObj((prev) => ({
                    ...prev,
                    [key]: {
                        ...prev[key],
                        id: isEmptyGuid(target.value) ? emptyGuid : target.value,
                    },
                }))
                break
            default:
                if (target.type === 'checkbox') {
                    value = target.checked
                } else {
                    value = target.value
                }
                setSettingsObj((prev) => setValueByKey(key, value, prev))
                break
        }
        resetFormError(key)
    }
    const getFormError = (name) => {
        return errorStates['updateWashSettings']?.formErrors[name]
    }
    const resetFormError = (name) => {
        setErrorStates(prev => {
            if (prev['updateWashSettings']?.formErrors) {
                delete prev['updateWashSettings'].formErrors[name]
            }
            return prev
        })
    }

    const updateSettings = async () => {
        await makeCall('updateWashSettings', async () => {
            await instMgmtApi.updateWashSettings(settingsObj)
        }, setErrorStates, setLoadingStates)
        washStore.setEnforceInitWash(false)
        await washStore.loadWashStation(true)
    }
    const handleOnChangeHideScanAfterTime = (value) => {
        washStore.setHideScanAfterTime(value)
        setHideScanAfterTime(washStore.hideScanAfterTime)
    }
    if (loadingStates.washSettings) {
        return (
            <div className='d-flex align-items-center justify-content-center'>
                <Spinner animation='border' variant='primary' />
            </div>
        )
    }

    return (
        <div>
            <h2>{t('washPage:settings')}</h2>
            <Row className='mb-3'>
                <Form.Group as={Row}>
                    <Form.Label column>{t('washPage:hideScanAfterTime')}:</Form.Label>
                    <Col>
                        <Form.Control
                            id='hideScanAfterTime'
                            name='hideScanAfterTime'
                            placeholder=''
                            value={hideScanAfterTime ?? 0}
                            onChange={(e) => handleOnChangeHideScanAfterTime(e.target.value)}
                            autoFocus
                        />
                    </Col>
                </Form.Group>
                <DividerLine />
                <div className="mb-5" />
                <Form.Group as={Row}>
                    <Form.Label column>{t('washAdmin:salesType')}</Form.Label>
                    <Col>
                        {loadingStates.washSalesTypes ? (
                            <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' variant='primary' />
                            </div>
                        ) : (
                            <ArraySelect
                                value={settingsObj?.salesType?.id ?? emptyGuid}
                                options={salesTypes}
                                noAutoSelect
                                name='salesType'
                                onChange={updateInputFields}
                                defaultOptionIsSelectable={isEmptyGuid(settingsObj?.salesType?.id ?? emptyGuid)}
                                returnEvent
                                disabled={!uiStore.allowWashSettingsAdministration}
                            />
                        )}
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>{t('washAdmin:defaultService')}</Form.Label>
                    <Col>
                        {loadingStates.washServices ? (
                            <div className='d-flex align-items-center justify-content-center'>
                                <Spinner animation='border' variant='primary' />
                            </div>
                        ) : (
                            <ArraySelect
                                value={settingsObj?.defaultService?.id ?? emptyGuid}
                                options={services}
                                noAutoSelect
                                name='defaultService'
                                onChange={updateInputFields}
                                defaultOptionIsSelectable={isEmptyGuid(settingsObj?.defaultService?.id ?? emptyGuid)}
                                returnEvent
                                disabled={!uiStore.allowWashSettingsAdministration}
                            />
                        )}
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column>
                        {t('washAdmin:stations')}
                    </Form.Label>
                    <Col>
                        <Form.Check
                            type='checkbox'
                            id='useWashStation'
                            name='useWashStation'
                            label={t('washAdmin:washStation')}
                            checked={true}
                            disabled={true}
                            onChange={updateInputFields}
                            isInvalid={!!getFormError('useWashStation')}
                        />
                        {!!getFormError('useWashStation') && (
                            <StyledValidationMessage>
                                {getFormError('useWashStation')}
                            </StyledValidationMessage>
                        )}
                        <Form.Check
                            type='checkbox'
                            id='useRepairStation'
                            name='useRepairStation'
                            label={t('washAdmin:repairStation')}
                            checked={settingsObj?.useRepairStation}
                            onChange={updateInputFields}
                            isInvalid={!!getFormError('useRepairStation')}
                            disabled={!uiStore.allowWashSettingsAdministration}
                        />
                        {!!getFormError('useRepairStation') && (
                            <StyledValidationMessage>
                                {getFormError('useRepairStation')}
                            </StyledValidationMessage>
                        )}
                        <Form.Check
                            type='checkbox'
                            id='useControlStation'
                            name='useControlStation'
                            label={t('washAdmin:controlStation')}
                            checked={settingsObj?.useControlStation}
                            onChange={updateInputFields}
                            isInvalid={!!getFormError('useControlStation')}
                            disabled={!uiStore.allowWashSettingsAdministration}
                        />
                        {!!getFormError('useControlStation') && (
                            <StyledValidationMessage>
                                {getFormError('useControlStation')}
                            </StyledValidationMessage>
                        )}
                    </Col>
                </Form.Group>
            </Row>
            <div className='spacing-down'>
                {uiStore.allowWashSettingsAdministration && <ButtonWithLoadingState
                    className='mb-2'
                    buttonText={t('saveButton')}
                    isLoading={loadingStates.updateWashSettings}
                    onClick={updateSettings}
                    disabled={loadingStates.updateWashSettings}
                />}
            </div>
        </div>
    )
}
export default withTranslation()(
    inject(
        'washStore',
        'uiStore'
    )(observer(WashSettings))
)
